import styled from 'styled-components';

export default {
  Video: styled.iframe`
    height: 100%;
    width: calc(16 / 9 * 100vh);
    min-width: 100%;
    min-height: calc(9 / 16 * 100vw);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    border: 0;
  `,

  Wrap: styled.div`
    min-height: 100vh;
    position: relative;
    overflow: hidden;
    text-align: center;
    padding: 220px 20px 20px;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
      padding: 140px 20px 20px;
    }
  `,

  HeaderWrap: styled.div`
    h2 {
      z-index: 1;
      position: relative;
      font-family: SchnyderWideSDemi;
      font-size: 64px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.19;
      letter-spacing: -0.85px;
      text-align: center;
      margin: 11.5rem auto 28px;

      @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
        font-size: 38px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.26;
        letter-spacing: -0.51px;
        text-align: center;

        max-width: 180px;
        margin: 0 auto 24px;
      }
    }
  `,

  TextWrap: styled.div`
    span {
      z-index: 1;
      position: relative;
      font-family: GTAmerica;
      font-size: 16px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: -0.36px;
      margin-bottom: 20vh;
      font-size: 18px;
      color: white;

      @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
        font-size: 16px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: -0.36px;
        text-align: center;

        max-width: 250px;
        margin: 0 auto;
      }
    }

    span > a {
      color: white;
      text-decoration: underline;
    }
  `,
};
